import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
import DataTable from "@components/DataTable.vue";
import MultiSelect from "@components/MultiSelect/MultiSelect.vue";
export default {
  components: {
    MultiSelect,
    DataTable
  },
  data() {
    return {
      loading: false,
      zip: "",
      distance: 50,
      programFilter: [],
      institutionFilter: [],
      zipFilter: [],
      activeFilters: true,
      dtConfig: {
        pageSize: 50,
        columns: [{
          key: "stacked",
          name: "Program",
          classes: "d-xl-none d-table-cell",
          renderer(data, row) {
            return `${row.programName} <small class="d-block text-primary font-weight-bold">${row.entityName}</small>`;
          }
        }, {
          key: "EntityName",
          name: "Institution",
          classes: "d-none d-xl-table-cell"
        }, {
          key: "Description",
          name: "Program",
          classes: "d-none d-xl-table-cell"
        }, {
          key: "Designation",
          name: "Designation",
          classes: "w-0 d-none d-md-table-cell text-center",
          renderer(data, row, mode) {
            let label = data.label;
            if (mode === "search") return label;
            return `<span class="badge p-2 badge-${data.bgColor}">${label}</span>`;
          }
        }, {
          key: "ReauthorizationScore",
          name: "Reauthorization",
          classes: "w-0 d-none d-md-table-cell text-center",
          renderer(data, row, mode) {
            let label = data.label;
            if (mode === "search") return label;
            return `<span class="badge p-2 badge-${data.bgColor}">${label}</span>`;
          }
        }],
        rowSelect: true,
        sorting: []
      },
      query: ""
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.cycleId = this.$store.state.cycleId;
      if (this.$route.query.entityId) this.$refs.institutionSelect.preselect = [this.$route.query.entityId];
    });
  },
  computed: {
    ineligibilityReasons() {
      return this.$store.state.ineligibilityReasons;
    },
    entities() {
      let aggregate = this.$store.state.entities.find(cea => cea.cycleId === this.$store.state.cycleId);
      if (!aggregate || !aggregate.entities) return [];
      return aggregate.entities;
    },
    entityProgramCategories() {
      return this.$store.state.entityProgramCategories;
    },
    programCategories() {
      return this.$store.state.programCategories;
    },
    hasFilters() {
      return this.institutionFilter.length > 0 || this.programFilter.length > 0 || this.hasZipFilter;
    },
    hasZipFilter() {
      return this.zipFilter.length > 0;
    },
    data() {
      return this.$store.state.entityProgramCategories.filter(ep => ep.CycleId == this.$store.state.cycleId).filter(ep => {
        if (this.zipFilter.length > 0 && !this.zipFilter.some(x => x === ep.Zip)) return false;
        if (this.institutionFilter.length > 0 && !this.institutionFilter.some(x => x.item.EntityId === ep.EntityId)) return false;
        if (this.programFilter.length > 0 && !this.programFilter.some(x => x.item.ProgramCategoryId === ep.ProgramCategoryId)) return false;
        return true;
      }).sort((a, b) => {
        let e1 = a.EntityName.toLowerCase();
        let e2 = b.EntityName.toLowerCase();
        let p1 = a.Description.toLowerCase();
        let p2 = b.Description.toLowerCase();
        if (p1 < p2) return -1;
        if (p1 > p2) return 1;
        if (e1 < e2) return -1;
        if (e1 > e2) return 1;
        return 0;
      });
    },
    invalidZip() {
      return this.zip != "" && !/^[0-9]{5}(?:-[0-9]{4})?$/.test(this.zip);
    },
    hiddenColumns() {
      return {
        ReauthorizationScore: this.$store.state.cycleId > 6 /*Cycle 2024 and on */
      };
    }
  },
  watch: {
    hasFilters(val) {
      if (!val) this.activeFilters = true;
    },
    "$route.query": function (val) {
      this.$refs.institutionSelect.toggleSelect(val.entityId);
    }
  },
  methods: {
    toggleActiveFilters(isActive) {
      this.activeFilters = isActive != undefined ? isActive : !this.activeFilters;
    },
    setInstitutionFilter(selected) {
      this.institutionFilter = selected;
    },
    setProgramFilter(selected) {
      this.programFilter = selected;
    },
    removeFilter(e, ref, key) {
      this.$refs[ref].toggleSelect(key, e);
      this.$refs[ref].setActive(false);
    },
    clearFilters(e) {
      e.preventDefault();
      this.$refs.programSelect.clear();
      this.$refs.programSelect.setActive(false);
      this.$refs.institutionSelect.clear();
      this.$refs.institutionSelect.setActive(false);
      this.zip = "";
      this.zipLocate();
    },
    zipLocate() {
      if (this.invalidZip || this.zip === "") this.zipFilter = [];else {
        this.loading = true;
        this.$store.dispatch("getZipsInRange", {
          zip: this.zip,
          miles: this.distance
        }).then(results => {
          this.zipFilter = results.length == 0 ? ["badZip"] : results;
        }, error => console.error(error)).finally(() => this.loading = false);
      }
    },
    rowSelected(data) {
      if (data.ProgramCategoryId) {
        this.$router.push({
          path: `/institutions/${data.EntityId}/programs/${data.ProgramCategoryId}`
        });
      }
    }
  }
};